import './App.css';
import { Botao } from './componentes/botao';


function App() {

  const botoes = [
    {
      nome: "WhatsApp",
      icone: "./img/whatsapp.png",
      link: "https://api.whatsapp.com/send?phone=5583994169282&text=Bom%20dia,%20gostaria%20de%20tirar%20uma%20d%C3%BAvida%20sobre%20o%20meu%20caso!"
    },
    {
      nome: "Instagram",
      icone: "./img/instagram.png",
      link: "https://www.instagram.com/brenoerik.adv/"
    },
    {
      nome: "E-mail",
      icone: "./img/mail.png",
      link: "mailto:brenoerikadv@gmail.com?subject=&body=Bom%20dia%2C%20gostaria%20de%20tirar%20uma%20d%C3%BAvida%20sobre%20o%20meu%20processo!"
    }
  ]

  return (
    <div className="App">
      <section className='ali-maior'>
        <div className='cabecalho'>
          <img className='imgEsquerda' src='/img/img01.jpg' alt='Atemis'/>
          <img className='imgDireita' src='/img/textImg.png' alt='Logo'/>
        </div>
        <div className='container'>
          <img src='/img/img03.png' alt='logotipo'/>
          <h2>Escritório de Advocacia Especializada</h2>
          <p>Entre em contato conosco e agende o seu atendimento!</p>
          <div className='botoes'>
            {botoes.map((botao)=><Botao key={botao.nome} nome={botao.nome} icon={botao.icone} link={botao.link}/>)}
          </div>
          <p style={{opacity: 0.5}}>Copyright © 2023 - Breno Erik Advocacia Especializada - Todos os direitos reservados</p>
        </div>
      </section>
    </div>
  );
}

export default App;
